<template>
    <div>
        <PageTitle :pages="pages" :title="titles.typePacksList"/>
        <div class="card">
            <div class="card-body">
                <h4 class="header-title mt-0">{{title}}</h4>
                <Tab :currentTabComponent="tabs[0].component" :show="showTab" :tabs="tabs"/>
            </div>
        </div>
    </div>
</template>

<script>
    import PageTitle from '../../common/PageTitle';
    import Tab from '../../common/Tab';
    import {titles} from '../../../utils/general/titles.js';
    import {name} from '../../../utils/general/routers.js';

    export default {
        name: 'Form',
        components: {PageTitle, Tab},
        data() {
            return {
                titles,
                showTab: false,
                title: titles.typePackAddExpression,
                pages: [],
                tabs: [
                    {
                        name: 'Infos',
                        component: 'InfosTypePack'
                    }
                ]
            };
        },
        created() {
            if (this.$route.params.typePackItem) {
                this.$cookies.set('typePackItem', this.$route.params.typePackItem);
            }
            if (this.$cookies.isKey('typePackItem')) {
                this.title = titles.typePackEditExpression;
            }

            this.tabSelected = this.tabs[0].component;
            this.pages.push(
                {
                    name: titles.settings,
                    router: name.settings,
                    active: false
                },
                {
                    name: titles.typePacksList,
                    router: name.typePackList,
                    active: false
                },
                {
                    name: this.title,
                    router: null,
                    active: true
                }
            );
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/appStyle.css';
</style>
